const RELOAD_KEY = "chunk-error-reload";

export function initChunkErrorHandler(): void {
	window.addEventListener("vite:preloadError", (event) => {
		event.preventDefault();

		const hasReloaded = sessionStorage.getItem(RELOAD_KEY);
		if (hasReloaded) {
			sessionStorage.removeItem(RELOAD_KEY);
			return;
		}

		sessionStorage.setItem(RELOAD_KEY, "true");
		window.location.reload();
	});
}
